export default "__VITE_ASSET__tWWD8FRb__"